import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/NodeLayout/NodeLayout.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress'; // const levelOffsetPx = 20
// selected: background: #F5F5F7;
// hover: #F4F4FA
// found self: rgb(176, 222, 255)

export var NodeLayoutRoot = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 30px;\n  display: flex;\n  align-items: center;\n  padding: 3px 8px 3px 6px;\n  background-color: transparent;\n  cursor: pointer;\n  white-space: nowrap;\n  user-select: none;\n\n  &:hover {\n    background-color: #f4f4f8;\n  }\n\n  ", "\n"])), function (p) {
  return p.hover ? "background-color: #f4f4f8;" : '';
});
export var NodeLayoutIcons = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-right: 8px;\n  padding-left: 6px;\n  display: flex;\n  align-items: center;\n"])));
export var NodeLayoutText = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  line-height: 1;\n"])));
export var NodeLayoutTextWrap = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n"])));
export var NodeLayoutEndContentWrap = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
export var IconLoader = styled(CircularProgress)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  margin-left: 10px;\n"])));